export default __webpack_public_path__ + "static/process-diagram-step1-equation-a47610ace76d3a077980d7a013640dbb.png";